export enum MetaViewOptions {
  Settings = 'settings',
  Statistics = 'statistics',
  Upcoming = 'upcoming',
}
